import React, { useSelector } from "react-redux";
import {
  selectImageBounds,
  selectSelectedElement,
  selectViewportBounds,
} from "../../app/slices/TrainingSlice";
import Interaction, {
  InteractionType,
  Marker,
} from "../../models/interactions/Interaction";
import Take360 from "../../models/Take360";
import MarkerPreview from "../previews/MarkerPreview";
import { getInteractionFromFactory } from "../interaction_factory/InteractionFactory";
import { selectUsedProps } from "../../app/slices/PropLibrarySlice";
import { useCallback } from "react";

export const useOverlay = () => {
  const selectedElement = useSelector(selectSelectedElement);
  const parentBounds = useSelector(selectViewportBounds);
  const imageBounds = useSelector(selectImageBounds);

  const usedProps = useSelector(selectUsedProps);

  function getTake360Overlay(take: Take360) {
    if (parentBounds && imageBounds)
      return take.is360Image ? <MarkerPreview variant="eye" /> : <></>;
  }

  const getInteractionOverlayElement = useCallback(
    () => (interaction: Interaction) => {
      var factoryResult = getInteractionFromFactory(interaction.type);
      return factoryResult ? factoryResult.View : <></>;
    },
    [usedProps]
  );

  const getOverlayElement = useCallback(() => {
    if (selectedElement) {
      if ((selectedElement as Take360).teleportMarker !== undefined) {
        return getTake360Overlay(selectedElement as Take360);
      } else if ((selectedElement as Interaction).type !== undefined) {
        return getInteractionOverlayElement()(selectedElement as Interaction);
      }
    } else {
      return <></>;
    }
  }, [selectedElement, getInteractionOverlayElement]);

  return { getOverlayElement, getInteractionOverlayElement } as const;
};
